import { Blueprint } from '../blueprint.class';
import { ToolResult } from '../types';

import { AddApplianceArgs, addApplianceTool } from './ai-tools/add-appliance.tool';
import { AddCutoutArgs, addCutoutTool } from './ai-tools/add-cutout.tool';
import { AddIslandArgs, addIslandTool } from './ai-tools/add-island.tool';
import { getApplianceCategoriesTool } from './ai-tools/get-appliance-categories.tool';
import { GetAppliancesArgs, getAppliancesTool } from './ai-tools/get-appliances.tool';
import { getCountertopMaterialOptionsTool } from './ai-tools/get-countertop-material-options.tool';
import { getCurrentDesignTool } from './ai-tools/get-current-design.tool';
import { GetLayoutOptionsArgs, getLayoutOptionsTool } from './ai-tools/get-layout-options.tool';
import { getSurroundMaterialOptionsTool } from './ai-tools/get-surround-material-options.tool';
import { ListAppliancesArgs, listAppliancesTool } from './ai-tools/list-appliances.tool';
import { listIslandsTool } from './ai-tools/list-islands.tool';
import { RemoveApplianceArgs, removeApplianceTool } from './ai-tools/remove-appliance.tool';
import { RemoveIslandArgs, removeIslandTool } from './ai-tools/remove-island.tool';
import { ResizeIslandArgs, resizeIslandTool } from './ai-tools/resize-island.tool';
import { SetCountertopMaterialArgs, setCountertopMaterialTool } from './ai-tools/set-countertop-material.tool';
import { SetSurroundMaterialArgs, setSurroundMaterialTool } from './ai-tools/set-surround-material.tool';
import { ReplaceApplianceArgs, replaceApplianceTool } from './ai-tools/replace-appliance.tool';
import { MoveApplianceGroupArgs, moveApplianceGroupTool } from './ai-tools/move-appliance-group.tool';
import { MoveApplianceToIslandArgs, moveApplianceToIslandTool } from './ai-tools/move-appliance-to-island.tool';
import { SwapAppliancePositionsArgs, swapAppliancePositionsTool } from './ai-tools/swap-appliance-positions.tool';
import { CleanKitchenArgs, cleanKitchenTool } from './ai-tools/clean-kitchen.tool';
import { SetKitchenShapeArgs, setKitchenShapeTool } from './ai-tools/set-kitchen-shape.tool';
import { UpdateIslandMinimumSizeArgs, updateIslandMinimumSizeTool } from './ai-tools/update-island-minimum-size.tool';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const executeToolCfn = async <T = unknown>(blueprint: Blueprint, name: string, args: any): Promise<ToolResult<T>> => {
	try {
		let result: ToolResult<unknown> | null = null;

		switch (name) {
			// Material tools
			case 'set_countertop_material':
				result = setCountertopMaterialTool(blueprint, args as SetCountertopMaterialArgs);
				break;
			case 'set_surround_material':
				result = setSurroundMaterialTool(blueprint, args as SetSurroundMaterialArgs);
				break;

			// Island tools
			case 'add_island':
				result = addIslandTool(blueprint, args as AddIslandArgs);
				break;
			case 'resize_island':
				result = resizeIslandTool(blueprint, args as ResizeIslandArgs);
				break;
			case 'remove_island':
				result = removeIslandTool(blueprint, args as RemoveIslandArgs);
				break;
			case 'list_islands':
				result = listIslandsTool(blueprint);
				break;
			case 'clean_kitchen':
				result = cleanKitchenTool(blueprint, args as CleanKitchenArgs);
				break;
			case 'set_kitchen_shape':
				result = setKitchenShapeTool(blueprint, args as SetKitchenShapeArgs);
				break;
			case 'update_island_minimum_size':
				result = updateIslandMinimumSizeTool(blueprint, args as UpdateIslandMinimumSizeArgs);
				break;

			// Appliance tools
			case 'add_appliance':
				result = addApplianceTool(blueprint, args as AddApplianceArgs);
				break;
			case 'add_cutout':
				result = addCutoutTool(blueprint, args as AddCutoutArgs);
				break;
			case 'remove_appliance':
				result = removeApplianceTool(blueprint, args as RemoveApplianceArgs);
				break;
			case 'replace_appliance':
				result = replaceApplianceTool(blueprint, args as ReplaceApplianceArgs);
				break;
			case 'move_appliance_group':
				result = moveApplianceGroupTool(blueprint, args as MoveApplianceGroupArgs);
				break;
			case 'move_appliance_to_island':
				result = moveApplianceToIslandTool(blueprint, args as MoveApplianceToIslandArgs);
				break;
			case 'swap_appliance_positions':
				result = swapAppliancePositionsTool(blueprint, args as SwapAppliancePositionsArgs);
				break;
			case 'list_appliances':
				result = listAppliancesTool(blueprint, args as ListAppliancesArgs);
				break;

			// Query tools
			case 'get_current_design':
				result = getCurrentDesignTool(blueprint);
				break;
			case 'get_layout_options':
				result = getLayoutOptionsTool(blueprint, args as GetLayoutOptionsArgs);
				break;
			case 'get_surround_material_options':
				result = getSurroundMaterialOptionsTool();
				break;
			case 'get_countertop_material_options':
				result = getCountertopMaterialOptionsTool();
				break;
			case 'get_appliance_categories':
				result = getApplianceCategoriesTool();
				break;
			case 'get_appliances':
				result = getAppliancesTool(blueprint, args as GetAppliancesArgs);
				break;

			default:
				result = { success: false, error: `Tool '${name}' not found.` };
		}

		return await Promise.resolve(result as ToolResult<T>);
	} catch (error) {
		return {
			success: false,
			errorCode: 'TOOL_EXECUTION_ERROR',
			error: error instanceof Error ? error.message : 'An unexpected error occurred.'
		};
	}
};
